export const PREFERENCES = {
  SHOW_TRAFFIC: 'displayTrafficConditions',
  SHOW_CLOSED_SIGEVENTS: 'showClosedSigEvents',
  INCIDENT_DISPLAY_ORDER: 'incidentDisplayOrder',
  SIGEVENT_DISPLAY_ORDER: 'sigEventsDisplayOrder',
  TIMESTAMP_FORMAT: 'timestampDisplayMode',
  DEFAULT_BASEMAP: 'preferredBasemap',
}
